import React, { useEffect, useState } from "react";
import { Users2, CheckCircle2, ExternalLink } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

/**
 * Admin/Manager widget: sets up ONE shared Google Calendar ("We Academy Team –
 * Alle AVGS-Termine") that mirrors every coach's appointments, color-coded per coach.
 */
export default function TeamCalendarConnect() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [setting, setSetting] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/calendar/team-appointments-calendar/status");
      setStatus(data);
    } catch { /* ignore, admin/manager only */ }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const setup = async () => {
    setSetting(true);
    try {
      const { data } = await api.post("/calendar/team-appointments-calendar/setup");
      toast.success(`Team-Kalender eingerichtet — ${data.appointments_mirrored} Termine übertragen, ${data.shared} Management-Mitglieder eingeladen`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSetting(false); }
  };

  if (loading || !status) return null;

  if (!status.configured) {
    return (
      <button
        onClick={setup}
        disabled={setting}
        data-testid="team-calendar-setup-btn"
        className="inline-flex items-center gap-2 px-4 py-2.5 text-xs font-medium border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white transition-colors disabled:opacity-50"
      >
        <Users2 size={12} strokeWidth={2} /> {setting ? "Richte ein…" : "Alle Coach-Termine in einem Kalender bündeln"}
      </button>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 px-4 py-2.5 border border-emerald-300 bg-emerald-50 text-emerald-900 text-xs" data-testid="team-calendar-connected-badge">
      <CheckCircle2 size={12} strokeWidth={2} />
      <span className="font-medium">Team-Kalender aktiv</span>
      <span className="text-emerald-700">· jeder Coach hat seine eigene Farbe</span>
      {status.open_url && (
        <a href={status.open_url} target="_blank" rel="noreferrer" className="ml-1 text-emerald-700 hover:text-emerald-900" title="In Google Kalender öffnen" data-testid="team-calendar-open-link">
          <ExternalLink size={12} strokeWidth={1.5} />
        </a>
      )}
    </div>
  );
}
